import { CustomSettingsActions } from 'client/actions/actionTypes'
import { actionCreatorAsync, AsyncAction } from 'client/actions/index'
import { CustomSettingsInterface } from 'client/Interfaces/CustomSettingsInterface'

import * as api from '../api/customSettings'

export function updateCustomSettings(settings: CustomSettingsInterface) {
  return (dispatch) => {
    return dispatch(
      actionCreatorAsync<CustomSettingsInterface>(CustomSettingsActions.UPDATE_CUSTOM_SETTINGS, () =>
        api.saveCustomSettings({ ...settings }),
      ),
    )
  }
}

export function getCustomSettings(): AsyncAction<CustomSettingsInterface> {
  return actionCreatorAsync<CustomSettingsInterface>(CustomSettingsActions.LOAD_CUSTOM_SETTINGS, async () => {
    return Promise.resolve(await api.getCustomSettings())
  })
}
